var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login-password-type"
  }, [_c('div', {
    staticClass: "switch-type"
  }, [_c('span', {
    staticClass: "type-text",
    class: [{
      'checked-type': _vm.data.type === 'password'
    }],
    on: {
      "click": function ($event) {
        return _vm.onChange('password');
      }
    }
  }, [_vm._v(` ${$t("g9ob2", "密码")} `)]), _c('span', {
    staticClass: "line"
  }), _c('span', {
    staticClass: "type-text",
    class: [{
      'checked-type': _vm.data.type === 'code'
    }],
    on: {
      "click": function ($event) {
        return _vm.onChange('code');
      }
    }
  }, [_vm._v(` ${$t("nbcoc3", "验证码")} `)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.data.type === 'password',
      expression: "data.type === 'password'"
    }]
  }, [_c('Form', {
    ref: "formPassword",
    attrs: {
      "model": _vm.data,
      "rules": _vm.ruleValidate
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "value": _vm.data.password,
      "type": "password",
      "prefix": "ios-lock-outline"
    },
    on: {
      "input": _vm.handleInputPassword,
      "on-enter": _vm.handleEnter
    }
  })], 1)], 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.data.type === 'code',
      expression: "data.type === 'code'"
    }]
  }, [_c('Form', {
    ref: "formCode",
    attrs: {
      "model": _vm.data,
      "rules": _vm.ruleValidate
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "verificationCode"
    }
  }, [_c('div', {
    staticClass: "verification-input"
  }, [_c('Input', {
    attrs: {
      "value": _vm.data.verificationCode,
      "maxlength": "6",
      "pattern": "\\d*",
      "placeholder": $t("nbcoc3", "验证码")
    },
    on: {
      "input": _vm.handleInputCode,
      "on-enter": _vm.handleEnter
    }
  }), _c('span', {
    staticClass: "get-code"
  }, [_vm.countdown > 0 ? _c('span', [_vm._v(` ${$t("px5sja6", "重新获取 (")}` + _vm._s(_vm.countdown) + "s) ")]) : _c('span', {
    staticClass: "resend",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(` ${$t("t09mz15", "获取验证码")} `)])])], 1)])], 1)], 1), _c('Verify', {
    ref: "verifyPassword",
    attrs: {
      "captcha-type": 'blockPuzzle',
      "img-size": {
        width: '300px',
        height: '200px'
      }
    },
    on: {
      "success": _vm.onSuccessVerify
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };